import React, { memo } from "react";
import { useTheme } from "styled-components";

const PieChartOutline: React.FC<{ isActive: boolean }> = ({ isActive }) => {
    const theme = useTheme();
    const fill = isActive
        ? theme.colors[theme.colorMode].text_Highest_Emphasis
        : theme.colors[theme.colorMode].text_Med_Emphasis;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14" fill="none" aria-hidden>
            <path
                d="M6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0ZM7.33333 1.38C9.74 1.68 11.6533 3.6 11.9533 6H8C7.63333 6 7.33333 5.7 7.33333 5.33333V1.38ZM1.33333 6.66667C1.33333 3.96 3.38 1.70667 6 1.38V11.96C3.38 11.6267 1.33333 9.37333 1.33333 6.66667ZM7.33333 11.9533V8C7.33333 7.63333 7.63333 7.33333 8 7.33333H11.9533C11.6533 9.74 9.74 11.6533 7.33333 11.9533Z"
                fill={fill}
                fillOpacity={0.92}
            />
        </svg>
    );
};

export default memo(PieChartOutline);
